// @ts-expect-error TS(7016): Could not find a declaration file for module 'map-...
import mapKeysDeep from "map-keys-deep-lodash"

const REPLACE_KEYS_TO_TREE_OBJ = {
  subCategorias: "children",
  nombre: "title",
}

export const categoriasSelector = (state: $TSMigrationFixMe) => state.categorias

export const categoriasOptionsWithParent = (state: $TSMigrationFixMe) => {
  const { allCategorias } = state.categorias

  return [
    ...allCategorias.map((categoria: $TSMigrationFixMe) => ({
      label: categoria.nombre,
      value: categoria.id,
    })),
    {
      label: "Sin padre",
      value: "",
    },
  ]
}

export const getCategoriasOptions = (state: $TSMigrationFixMe) => {
  const { allCategorias } = state.categorias

  return [
    ...allCategorias.map((categoria: $TSMigrationFixMe) => ({
      label: categoria.nombre,
      value: categoria.id,
    })),
  ]
}

/**
 * Replace some keys for react-sortable-tree can works properly
 */
export const categoriasTreeObjSelector = (state: $TSMigrationFixMe) => {
  const { categoriasPadre } = state.categorias

  return mapKeysDeep(
    categoriasPadre,
    (_: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      return REPLACE_KEYS_TO_TREE_OBJ[key] ? REPLACE_KEYS_TO_TREE_OBJ[key] : key
    }
  )
}

export const categoriaSelectedSelector = (state: $TSMigrationFixMe) =>
  state.categorias?.categoriaSelected

export const posiblesPadresOptionsSelector = (state: $TSMigrationFixMe) => {
  const { posiblesPadres } = state.categorias

  return [
    ...posiblesPadres.map((categoria: $TSMigrationFixMe) => ({
      label: categoria.nombre,
      value: categoria.id,
    })),
    {
      label: "Sin padre",
      value: "",
    },
  ]
}

export const canEditCategoriasSelector = (state: $TSMigrationFixMe) => {
  const { deletingCategoria, updatingCategoria, creatingCategoria } =
    state.categorias
  return !deletingCategoria && !updatingCategoria && !creatingCategoria
}
